import {
  Accordion,
  AccordionHeader,
  AccordionItem,
  AccordionPanel,
  Box,
  Heading,
} from '@joinrepublic/dls-ui-kit';

import { CategoryList } from './category-list';

export const MobileCategoryLists = () => (
  <Accordion allowToggle>
    <AccordionItem p="0">
      {
        // TODO: https://linear.app/republic/issue/USMKT-1457/change-all-hardcoded-colours-for-the-new-hp-to-the-proper-tokens
      }
      <Box borderY="1px solid" borderColor="whiteAlpha.500">
        <AccordionHeader py="4" px="0" color="white">
          <Heading size="title-sm" my="0" color="white">
            Invest
          </Heading>
        </AccordionHeader>
        <AccordionPanel px="0" pt="0" pb="4">
          <CategoryList
            items={[
              { label: 'Start investing', url: '/investment-opportunities' },
              { label: 'Accredited deals', url: '/ventures' },
              { label: 'Trade', url: '/trading' },
            ]}
          />
        </AccordionPanel>
      </Box>
    </AccordionItem>
    <AccordionItem p="0">
      <Box borderBottom="1px solid" borderColor="whiteAlpha.500">
        <AccordionHeader py="4" px="0" color="white">
          <Heading size="title-sm" my={0} color="white">
            Raise
          </Heading>
        </AccordionHeader>
        <AccordionPanel px="0" pt="0" pb="4">
          <CategoryList
            items={[
              { label: 'Raise capital', url: '/raise' },
              { label: 'Equity rewards', url: '/sharedrops' },
              { label: 'Launch a token', url: '/launchpad' },
            ]}
          />
        </AccordionPanel>
      </Box>
    </AccordionItem>

    <AccordionItem p="0">
      {({ isExpanded }) => (
        <Box
          borderBottom={isExpanded ? 'none' : '1px solid'}
          borderColor="whiteAlpha.500"
        >
          <AccordionHeader py="4" px="0" color="white">
            <Heading size="title-sm" my={0} color="white">
              Build
            </Heading>
          </AccordionHeader>
          <AccordionPanel px="0" pt="0" pb="2">
            <CategoryList
              items={[
                { label: 'RWA tokenization', url: '/tokenization' },
                { label: 'Blockchain infrastructure', url: '/infrastructure' },
                { label: 'Advisory and research', url: '/advisory' },
              ]}
            />
          </AccordionPanel>
        </Box>
      )}
    </AccordionItem>
  </Accordion>
);
